import * as React from 'react';

import { translate } from '~l10n/client';

import { toNumber, toPrecision } from '~shared/utils/number';

export const Point = ({ gradingWeight }: { gradingWeight: number }) => {
  const points = toNumber(toPrecision(gradingWeight, 2));
  return (
    <span className="points">
      {gradingWeight === 1
        ? translate('1 point')
        : translate('{0} points').format(points)}
    </span>
  );
};
